import styled from 'styled-components';

export const MenuItem = styled.div`
	font-size: 15px;
	color: #5d81ec;
	font-weight: bold;
	font-family: 'Karla', sans-serif;

	a {
		color: #5d81ec;
		text-decoration: none;
	}
`;


// WEBPACK FOOTER //
// ./client/redesign/web/components/styled.js